import { useState } from "react";
import AgentsAPI from "../../../api/AgentsAPI";

const useUpdateAgentPassword = () => {
	const [loading, setLoading] = useState(false);

	const updateAgentPassword = async (currentPassword, newPassword) => {
		setLoading(true);

		try {
			const result = await AgentsAPI.updateAgentPassword(currentPassword, newPassword);
			return { success: true, data: result };
		} catch (error) {
			console.error("Failed to update agent password:", error);
			return { success: false, error: error.message };
		} finally {
			setLoading(false);
		}
	};

	return {
		updateAgentPassword,
		loading,
	};
};

export default useUpdateAgentPassword;
